export const FeatureFlags = Object.freeze({
  SHOW_UI_BUILDER_NAVIGATION: false,
});
